
import Vue from 'vue';

export default Vue.extend({
	props: {
		id: {
			type: String,
			default: 'default-color',
		},
		minHue: {
			type: Number,
			default: 0,
		},
		maxHue: {
			type: Number,
			default: 120,
		},
		minName: {
			type: String,
			default: 'min',
		},
		maxName: {
			type: String,
			default: 'max',
		},
		unit: {
			type: String,
			default: '',
		},
	},

	computed: {
		minFormattedName(): string {
			if (this.minName === 'min') {
				return `${this.$t('min').toString()}${this.unit}`;
			}
			return `${this.minName}${this.unit}`;
		},

		maxFormattedName(): string {
			if (this.maxName === 'max') {
				return `${this.$t('max').toString()}${this.unit}`;
			}
			return `${this.maxName}${this.unit}`;
		},
	},

	methods: {
		colorScale(percentage: number, minHue = 0, maxHue = 120): string {
			const hue: number = (percentage / 100) * (maxHue - minHue) + minHue;
			return `hsl(${hue}, 100%, 50%)`;
		},
	},
});
